import React, { createContext, useContext, useState } from 'react';
import SessionData from "./sessionData.json";
import dispatcher from '../../events/dispatcher';
import { useSessionWatcher } from '../util/useSessionWatcher';
import SessionModal from "../../components/common/SessionModal";
// Create the UserSessionContext
const UserSessionContext = createContext();

// Custom hook to access the UserSessionContext
export const useUserSession = () => {
  return useContext(UserSessionContext);
};

// Provider component to wrap your application
export const UserSessionProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Initial user state is null
  const [token, setToken] = useState(null); // Token for authenticated sessions
  const [tagEntities, setTagEntities] = useState(null); 
  const [sessionStore, setSessionStore]= useState({...SessionData});
  const [showIdleWarning, setShowIdleWarning] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  // Function to log in a user
  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    SessionData.SESSION.authToken=authToken;
    SessionData.SESSION.userData=userData;
    setSessionStore({...SessionData});
 

    //Optionally save session data in localStorage/sessionStorage
    //localStorage.setItem('user', JSON.stringify(userData));
    //localStorage.setItem('token', authToken);
  };
    
  // Function to log out the user
  const logout = () => {
    setUser(null);
    setToken(null);
    SessionData.SESSION.authToken=null;
    SessionData.SESSION.userData=null;
    setSessionStore({...SessionData});
    setSessionExpired(false);

  };

  const sessionData=SessionData;

  const refreshToken = async () => {
    const refresedDate = await dispatcher.ACCESS_REFRESH(); 
    if (refresedDate) {
      setUser({ ...user, ...refresedDate });
      setToken(refresedDate.idToken);
    }
  };

  
  const { triggerActivity } = useSessionWatcher({
    getToken:()=>token,
    onExpire: () => setSessionExpired(true),
    onRefresh: refreshToken,
    onPreIdleWarning: () => setShowIdleWarning(true),
  });

  return (
    <UserSessionContext.Provider value={{
      user, 
      token,
      setUser,
      login, 
      logout, 
      tagEntities,
      setTagEntities,
      sessionData, 
      sessionStore, 
      setSessionStore}}>
      {children}
      {sessionExpired && <SessionModal 
      config={{
        "title":"Session Expired",
        "message":"For your security, your session has expired. Please log in again to continue.",
        "buttonLabel":"Re-authenticate",
        "stateHandler":true,
        "onCloseHandler":() => {
            window.location.reload();
        },
        "onClickHandler":() => {
            window.location.reload();
        }
      }}
      />}
      {showIdleWarning && <SessionModal 
      config={{
        "title":"You're about to be logged out",
        "message":"You've been inactive for a while. You'll be logged out soon for security.",
        "buttonLabel":" I'm still here",
        "stateHandler":true,
        "onCloseHandler":() => {
          triggerActivity();
          setShowIdleWarning(false)
        },
        "onClickHandler":() =>{ 
          triggerActivity();
          setShowIdleWarning(false);
        }
      }}
      />}
    </UserSessionContext.Provider>
  );
};
